export const filterLeagues = (leagues, sportId) => {
    return leagues.filter(league => league.sportId === sportId);
};
//# sourceMappingURL=filterLeagues.js.map